export const generateRandomSentence = () => {
  const subjects = [
    'Direct deposit',
    'Cash withdrawal',
    'Payment',
    'Transfer',
    'Restaurant charge',
    'Sent',
    'Payment',
    'Scheduled',
    'Cashback credit',
  ];
  const verbs = ['at', 'to', 'from'];
  const objects = [
    'employer',
    'ATM (Downtown Branch)',
    'FreshMart Supermarket',
    'City Utilities',
    'The Burger Spot',
    'Amazon.ca',
    'ABC Corp (EUR)',
    'International Vendor (USD)',
  ];

  const randomSubject = subjects[Math.floor(Math.random() * subjects.length)];
  const randomVerb = verbs[Math.floor(Math.random() * verbs.length)];
  const randomObject = objects[Math.floor(Math.random() * objects.length)];

  return `${randomSubject} ${randomVerb} ${randomObject}.`;
};

export const generateRandomTransactionType = () => {
  const transactionTypes = ['DEBIT', 'CREDIT'];
  const randomIndex = Math.floor(Math.random() * transactionTypes.length);
  return transactionTypes[randomIndex];
};

export const generateRandomNumberWithinRange = (from: number, to: number, float: boolean, floatPrecisions = 0) => {
  const min = from;
  let num = Math.random() * (to - min) + min;

  if (!float) {
    num = Math.floor(num);
  }

  if (floatPrecisions > 0) {
    num = parseFloat(num.toFixed(floatPrecisions));
  }

  return num;
};

export const generateRandomBoolean = () => {
  return Math.random() < 0.5;
};

export const generateRandomDateWithinRange = (start: Date, end: Date) => {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

export const generateRandomUuid = () => {
  return crypto.randomUUID();
};
